import React from 'react';
import {
  translate as t,
  GET_LIST,
  CREATE,
} from 'admin-on-rest';
import {
  SelectField,
  MenuItem,
  Dialog,
  TextField,
  RaisedButton,
} from 'material-ui';
import ChipInput from 'material-ui-chip-input';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { has } from 'lodash';

import TinyMCE from 'react-tinymce';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/skins/lightgray/skin.min.css';
// Any plugins you want to use has to be imported
import 'tinymce/plugins/media';
import 'tinymce/plugins/image';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
import { getTranslationByLocale } from '../../utils/TranslationUtils';
import { callApi } from '../../client/apiToolbox';

// react-tinymce use global ref
window.tinymce = tinymce;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const styles = {
  dialogContent: {
    width: '95%',
    height: '95%',
    maxWidth: '996px',
  },
  dialogBody: {
    overflow: 'scroll',
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '2em',
  },
};

class NewsPublisher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: 'sv',
      open: false,
      positions: [],
      selectedPositions: [],
      tags: ['Pinchoversity'],
      courseTitle: '',
      body: '',
      status: '',
    };
  }

  componentWillMount = async () => {
    await restClient(GET_LIST, 'positions', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((positions) => this.setState({ positions: positions.data }))
      .catch((e) => console.log('positions get E', e));

    this.getTags();
    this.setState({
      body: `Nu finns kursen ${this.props.record.title ? this.props.record.title : ''}`,
      title: `Ny kurs: ${this.props.record.title ? this.props.record.title : ''}`,
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if (has(nextProps.record, 'title')) {
      this.setState({
        body: `Nu finns kursen ${this.props.record.title ? this.props.record.title : ''}`,
        title: `Ny kurs: ${this.props.record.title ? this.props.record.title : ''}`,
      });
    }
  }

  getTags = () => {
    callApi(`${API_BASE_URL}/utils/news/tags`, 'GET')
      .then((data) => { console.log('tags data', data); this.setState({ initialTags: data.json }); })
      .catch((e) => console.log('tags E', e));
  }

  publishNews = () => {
    const { selectedLanguage, title, body, tags, positions } = this.state;
    const newsBody = { language: selectedLanguage, title, body, tags, positions };
    restClient(CREATE, 'news', { data: newsBody })
      .then((res) => console.log('news successfully added', res), this.setState({ status: this.props.translate('academy.newsPublishSuccess') }))
      .catch((e) => console.log('publishNews E', e));
  }


  handleOpen = () => this.setState({ open: true });
  handleClose = () => this.setState({ open: false });
  handleTextChange = (e, val) => this.setState({ [e.target.name]: val });
  handlePositionsChange = (even, key, value) => this.setState({ selectedPositions: value });
  handleTagsChange = (val) => this.setState((prevState) => ({ tags: val, initialTags: [...prevState.initialTags, ...val] }));
  handleTinyMCChange = (e) => this.setState({ body: e.target.getContent() });

  handleChange = (event, index, value) => this.setState({ selectedLanguage: value });

  render() {
    const { selectedLanguage, selectedPositions, positions, initialTags, body } = this.state;
    const { translate, locale } = this.props;
    const actions = [
      <RaisedButton onClick={this.handleClose} label={translate('cancel')} />,
      <RaisedButton onClick={this.handleClose} primary label={translate('save')} />,
    ];

    console.log('rec', this.props, this.state);
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-around', padding: '10px' }}>
          <RaisedButton onClick={this.handleOpen} label={translate('edit.item', { item: translate('news.news.sg') })} />
          <RaisedButton primary onClick={this.publishNews} label={translate('news.post')} />
        </div>
        {this.state.status && <div style={{ textAlign: 'center', padding: '10px' }}> {this.state.status} </div>}

        <Dialog
          title={translate('edit.item', { item: translate('news.news.sg') })}
          actions={actions}
          open={this.state.open}
          onRequestClose={this.handleClose}
          contentStyle={styles.dialogContent}
          bodyStyle={styles.dialogBody}
          actionsContainerStyle={styles.actionContainer}
          autoScrollBodyContent
        >

          <SelectField
            floatingLabelText={translate('language')}
            value={selectedLanguage}
            onChange={this.handleLanguageChange}
          >
            <MenuItem value="sv" primaryText={translate('languages.sv')} />
            <MenuItem value="en" primaryText={translate('languages.en')} />
          </SelectField>

          <TextField
            onChange={this.handleTextChange}
            floatingLabelText={translate('title')}
            value={this.state.title}
            name="title"
            style={styles.textField}
            fullWidth
          />

          <SelectField
            floatingLabelText={translate('position')}
            value={selectedPositions}
            onChange={this.handlePositionsChange}
            multiple
            fullWidth
            errorText={translate('positionsHintText')}
            errorStyle={{ color: 'darkslategrey' }}
            floatingLabelFocusStyle={{ color: 'darkslategrey' }}

          >
            {
              positions.map((position) => (
                <MenuItem
                  value={position.identifier}
                  primaryText={getTranslationByLocale(position.name, locale)}
                  checked={selectedPositions.includes(position.identifier)}

                />
              ))
            }
          </SelectField>

          <ChipInput
            hintText={translate('tag')}
            dataSource={initialTags}
            fullWidth
            defaultValue={['Pinchoversity']}
            onChange={this.handleTagsChange}
            floatingLabelText={translate('tags')}
          />

          <TinyMCE
            // id={id}
            content={body}
            config={{
              skin: false,
              theme: 'modern',
              menubar: 'file edit insert',
              plugins: 'image media',
            }}
            onChange={(e) => this.handleTinyMCChange(e)}
          />
        </Dialog>
      </div>
    );
  }
}

NewsPublisher.defaultProps = {
  addField: true,
};


const selector = getFormValues('record-form');

export default connect((state) => ({ record: selector(state) }), undefined)(t(NewsPublisher));
